module.exports = __webpack_public_path__ + "files/0270dd787c686087b445e35f2bfec48e.png";